<template>
  <div class="thumb editorpick-cell">
    <a
      href="javascript:void(0)"
      role="button"
      @click.prevent="$emit('on-click')"
    >
      <div class="thumb-image">
        <div class="picture-area">
          <picture>
            <img
              v-lazy="getInnerPosterLazyImage()"
              class="thumb-img"
              :alt="altTitle"
            />
          </picture>
        </div>
      </div>
      <div class="sub-title">
        <div
          ref="title"
          v-title-list="{
            titleList: cellInfo.title_list,
          }"
          class="sub-right"
        ></div>
      </div>
    </a>
    <div class="editorpick-cell-backdrop" :style="backgroundImage"></div>
  </div>
</template>
<script>
  import CellMixIn from '@/mixins/cell.mixin'
  import { titleList } from '@/common/resources/directives'
  import _ from 'lodash'
  import shave from '@/common/utils/customShave'
  import { resizeThumbnail } from '@/common/utils/image'
  import { URL_IMG_DOMAIN } from '@/common/resources/const'
  import { getDomainWithPrefix } from '@/common/utils/common'

  export default {
    name: 'EditorPickPackageCell',
    directives: {
      titleList,
    },
    mixins: [CellMixIn],
    props: {
      cellInfo: {
        type: Object,
      },
      thumbnailInfo: {
        type: Object,
      },
    },
    data() {
      return {}
    },
    computed: {
      backgroundImage() {
        // 에디터픽은 기존 사용하던 방식으로 이미지 호출, 도메인만 새로운 이미지 서버 도메인으로 변경
        const IMAGE_WIDTH = '_w960'
        const PC_BLUR_KEY = '_blur2'
        const thumbnailUrl = _.get(this.cellInfo, 'thumbnail', '')
          .replace('http://', '')
          .replace('https://', '')
        const imagePath = thumbnailUrl
          .replace('dev-image.wavve.com', '')
          .replace('qa-image.wavve.com', '')
          .replace('dev-image.cdn.wavve.com', '')
          .replace('qa-image.cdn.wavve.com', '')
          .replace('img.wavve.com', '')
          .replace('image.wavve.com', '')
          .replace('image.cdn.wavve.com', '')

        if (imagePath === '') {
          return undefined
        }

        const pathArr = imagePath.split('/')
        const fileNameAndExt = pathArr.pop()
        const [fileName, ext] = fileNameAndExt.split('.')
        const completeFileName = [
          fileName + IMAGE_WIDTH + PC_BLUR_KEY,
          ext,
        ].join('.')
        const blurImagePath = [...pathArr, completeFileName].join('/')
        const imageUrl = `https://${URL_IMG_DOMAIN}${blurImagePath}`

        return `background-image: url(${getDomainWithPrefix(imageUrl)});`
      },
    },
    methods: {
      loaded(el) {
        this.$nextTick(() => {
          _.forEach(el.querySelectorAll('.line1'), (line1El) => {
            shave(line1El, 28)
          })
        })
      },
      getInnerPosterLazyImage() {
        let thumbnail = _.get(this.cellInfo, 'thumbnail', '')
        if (thumbnail === '') {
          thumbnail = this.thumbnailInfo.placeholderImage
        }
        return {
          src: resizeThumbnail(thumbnail, {
            width: 128,
            height: 180,
          }),
          error: this.thumbnailInfo.placeholderImage,
          loading: this.thumbnailInfo.placeholderImage,
        }
      },
    },
  }
</script>
